import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-169e5420"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "grad",
    gradientTransform: "rotate(90)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#be90ff",
      "stop-opacity": "1"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "white",
      "stop-opacity": "0.4"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Area = _resolveComponent("Area")!
  const _component_Line = _resolveComponent("Line")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Responsive = _resolveComponent("Responsive")!

  return (_openBlock(), _createBlock(_component_Responsive, { class: "w-full" }, {
    main: _withCtx(({ width }) => [
      _createVNode(_component_Chart, {
        size: { width, height: 420 },
        data: _ctx.data,
        margin: _ctx.margin,
        direction: _ctx.direction,
        axis: _ctx.axis
      }, {
        layers: _withCtx(() => [
          _createVNode(_component_Grid, { strokeDasharray: "2,2" }),
          _createVNode(_component_Area, {
            dataKeys: ['name', 'pl'],
            type: "monotone",
            areaStyle: { fill: 'url(#grad)' }
          }, null, 8, ["areaStyle"]),
          _createVNode(_component_Line, {
            dataKeys: ['name', 'pl'],
            type: "monotone",
            lineStyle: {
              stroke: '#9f7aea'
            }
          }),
          _createVNode(_component_Marker, {
            value: 1000,
            label: "Start Value",
            color: "#76c893",
            strokeWidth: "2",
            strokeDasharray: "6 6"
          }),
          _createVNode(_component_Marker, {
            value: 2000,
            label: "Stop Value",
            color: "#9f7aea",
            strokeWidth: "2",
            strokeDasharray: "6 6"
          }),
          _hoisted_1
        ]),
        widgets: _withCtx(() => [
          _createVNode(_component_Tooltip, {
            borderColor: "#9f7aea",
            config: {
              pl: { color: '#9f7aea' },
              avg: { hide: true },
              inc: { hide: true }
            }
          })
        ]),
        _: 2
      }, 1032, ["size", "data", "margin", "direction", "axis"])
    ]),
    _: 1
  }))
}